import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {injectIntl, intl } from 'react-intl';
import * as modalActions from '../../actions/common/modalActions';
import * as maintenanceModeActions from '../../actions/common/maintenanceModeActions';
import {messages} from  '../common/Translations';

const CHECKING_INTERVAL = 2000;

class MaintenanceModeChecker extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(newProps) {
        if(this.props.maintenanceMode === false && newProps.maintenanceMode === true) {
            this.startMaintenanceMode();
        }
        else if(this.props.maintenanceMode === true && newProps.maintenanceMode === false) {
            window.location.reload(true);
        }
    }

    startMaintenanceMode() {
        this.showAlert();
        window.setInterval(() => {
            this.props.actions.checkMaintenanceMode();
        }, CHECKING_INTERVAL)
    }

    showAlert() {
        const intl = this.props.intl;
        this.props.actions.showSweetAlertModal(
            intl.formatMessage(messages.maintenanceAlertHeader),
            <div>
                <hr/>
                <h3>{intl.formatMessage(messages.maintenanceAlertContent)}</h3>
                <br/>
                <span>{intl.formatMessage(messages.maintenanceAlertFooter)}</span>
            </div>,
            false
        );
    }

    render() {
        return null;
    }
}

function mapStateToProps(state) {
    return {
        maintenanceMode: state.maintenanceMode,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                modalActions,
                maintenanceModeActions
            ), dispatch
        )
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MaintenanceModeChecker));


// WEBPACK FOOTER //
// ./web/src/components/common/MaintenanceModeChecker.jsx